import { useEffect, useState } from 'react';

export function useCSR() {
  const [isCSR, setIsCSR] = useState(false);

  useEffect(() => {
    setIsCSR(true);
  }, []);

  return isCSR;
}
